// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ucQM","tabsBox":"styles_tabsBox__1Tquq","createButton":"styles_createButton__1visW"};